<template>
  <div class="wt-form-tablelist-container">

    <div class="wt-form-tablelist-title" v-if="form.formButtonsData && form.formButtonsData.length > 0">
      <div class="buttons">

        <el-form size="small" class="wt-form-btns" :inline="true">
          <template v-if="!$slots.default">
            <template v-for="(item, index) in form.formButtonsData" >
              <template v-if="!item.permission">
                <el-upload
                  v-if="item.type === 'IMPORT'"
                  style="display: inline-block;"
                  :action="item.url"
                  :show-file-list="false"
                  :limit="1"
                  :headers="importHeaders"
                  accept=".xlsx"
                  :on-success="onSuccess"
                  :before-upload="beforeUpload"
                  :file-list="importList"
                  :data="item.exrtaImportData ? item.exrtaImportData : {}">
                  <el-button  :type="item.className ? item.className : 'default'" size="small" style="margin: 0 10px;">{{item.name}}</el-button></el-upload>
                  <div v-else class="search-form-btn">
                    <el-button size="small" v-bind:key="index" :type="item.className ? item.className : 'default'" @click="toClickAction({}, item)">{{item.name}}</el-button>
                  </div>
              </template>
              <wt-auth v-else class="search-form-btn" :hasAnyPremission="form.formCode + ':' + item.permission" v-bind:key="index">
                <el-upload
                  v-if="item.type === 'IMPORT'"
                  style="display: inline-block;"
                  :action="item.url"
                  :show-file-list="false"
                  :limit="1"
                  :headers="importHeaders"
                  accept=".xlsx"
                  :on-success="onSuccess"
                  :before-upload="beforeUpload"
                  :file-list="importList"
                  :data="item.exrtaImportData ? item.exrtaImportData : {}">
                  <el-button  :type="item.className ? item.className : 'default'" size="small">{{item.name}}</el-button></el-upload>
                <el-button v-else size="small" :type="item.className ? item.className : 'default'" @click="toClickAction({}, item)">{{item.name}}</el-button>
              </wt-auth>
            </template>
          </template>
          <slot name="default"></slot>
          <slot name="custom"></slot>
        </el-form>
      </div>
    </div>
    <slot name="tableTopCustom"></slot>
    <div class="wt-form-tablelist-content">

      <el-table class="wt-table" header-row-class-name="wt-table-header-row" v-loading.body="form.isFormLoading" element-loading-text="加载中.."
                :data="form.formResult.list" :default-sort="{prop: '', order: 'descending'}"
                @selection-change="onMultipleSelectionChange" @sort-change="onSortChange" size="mini"
                @current-change="onCurrentChange"
                fit highlight-current-row>

        <template v-if="form.formTableProp && form.formTableProp.selection">
          <el-table-column v-if="form.formTableProp.selection === 'single'" width="45">
            <template slot-scope="scope">
              <input type="radio" :name="formUuid" :checked="formSelectedId === scope.row.id">
            </template>
          </el-table-column>
          <el-table-column v-else type="selection" width="45"></el-table-column>
        </template>
        <!-- <el-table-column v-else type="selection" width="45"></el-table-column> -->
        <template v-if="form.formTableProp && form.formTableProp.index">
          <el-table-column type="index" width="80" :label="form.formTableProp.indexLabel ? form.formTableProp.indexLabel : '序号'"></el-table-column>
        </template>
        <el-table-column v-for="(item, index) in form.formTableData" :key="index" :label='item.name' :prop="item.key"
                         :sortable="item.sortable" :min-width="item.minWidth" :width="item.width" v-bind="item.attr">

          <template slot-scope="scope">

            <i v-if="item.type === 'datetime'" class="el-icon-time"></i>
            <template v-if="item.type === 'enum'" >
              <span :class="getDataValueClass(scope.row, item)">{{getDataValue(scope.row, item)}}</span>
            </template>
            <template v-else-if="item.type === 'custom'">
              <slot :name="item.key" :item="item" :row="scope.row" :index="scope.$index" />
            </template>
            <template v-else>
              <span>{{getDataValue(scope.row, item)}}</span>
            </template>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" v-if="form.formTableProp ? !form.formTableProp.buttonHidden : true"
                         :width="form.formTableProp ? form.formTableProp.buttonWidth : ''"
                         :min-width="form.formTableProp ? form.formTableProp.buttonMinWidth : ''">
          <template slot-scope="scope">
            <slot name="wtFormTableListButtonsBefore" :row="scope.row" />
            <template v-for="(item, index) in form.formTableButtonsData" v-if="!isButtonHidden(item, scope.row)">
              <wt-auth class="search-form-btn" v-bind:key="index" :hasAnyPremission="!item.permission ? '' : form.formCode + ':' + item.permission">
                <el-button size="mini"
                           :type="item.className ? item.className : 'default'" @click="toClickAction(scope.row, item)"
                >{{ item.condition ? item.value[scope.row[item.condition]] : item.name}}</el-button>
              </wt-auth>
            </template>

            <slot name="wtFormTableListButtonsAfter" :row="scope.row" :index="scope.$index" />

          </template>
        </el-table-column>

      </el-table>

    </div>

    <wt-detail-page v-if="form.formComponent.add" :visible.sync="isAddDialogVisible" :component-name="form.formComponent.add.componentName" component-type="add" :detail-data="form.formComponent.add.detailData" @on-button-action="onButtonAction" />
    <wt-detail-page v-if="form.formComponent.view" :visible.sync="isViewDialogVisible" :component-name="form.formComponent.view.componentName" component-type="view" :detail-data="form.formComponent.view.detailData" @request-list="requestList" @on-button-action="onButtonAction" />
    <wt-detail-page v-if="form.formComponent.edit" :visible.sync="isEditDialogVisible" :component-name="form.formComponent.edit.componentName" component-type="edit" :detail-data="form.formComponent.edit.detailData" @request-list="requestList" @on-button-action="onButtonAction" />
  </div>
</template>

<script>
import request from '@/utils/request'
import { mapState } from 'vuex'
import { getToken } from '@/utils/auth'

export default {
  name: 'wt-form-table-list',
  props: ['form'],
  data() {
    return {
      formUuid: '',
      formSelectedId: '',
      isAddDialogVisible: false,
      isViewDialogVisible: false,
      isEditDialogVisible: false,
      importList: [],
      importHeaders: {
        'x-access-token': ''
      },
      importTimer: null,
      importLoading: null
    }
  },
  created() {
    this.importHeaders['x-access-token'] = getToken()
    this.formUuid = this.$wtUtil.uuid()
    if (!this.form.formResult) {
      this.form.formResult = {}
    }
    if (!this.form.formResult.list) {
      this.form.formResult.list = []
    }
  },
  methods: {
    isButtonHidden(item, row) {
      // 如果 hidden 是布尔值，直接返回
      if (typeof item.hidden === 'boolean') {
        return item.hidden
      }
      // 如果 hidden 是函数，执行函数判断
      if (typeof item.hidden === 'function') {
        return item.hidden(row)
      }
      return false
    },
    onButtonAction(row) {
      this.$emit('on-button-action', row)
    },
    /*  ------------------------- 表格和分页  -------------------------  */
    onMultipleSelectionChange(data) {
      this.form.formSelectedList = data
    },
    onCurrentChange(row) {
      if (this.form.formTableProp && this.form.formTableProp.selection && this.form.formTableProp.selection === 'single') {
        this.form.formSelectedList = []
        this.form.formSelectedList.push(row)
        this.formSelectedId = row.id
      }
    },
    onSortChange(column) {
      //  点击排序
      this.form.pageData.sortName = column.prop
      this.form.pageData.sortOrder = column.order
      // this.$emit('request-form-list')
      this.requestList()
    },
    toClickAction(row, item) {
      // 增加兼容对象逻辑
      if (item.action === 'DELETE_LIST') {
        this.toDeleteMutil()
      } else if (item.action === 'ADD') {
        this.isAddDialogVisible = true
        if (this.form.formComponent && this.form.formComponent.add && this.form.formComponent.add.value) {
          this.$store.dispatch(this.form.formComponent.add.value, this.form.formComponent.add.params)
        }
        // 不使用store
        if (this.form.formComponent && this.form.formComponent.add && this.form.formComponent.add.detailData) {
          this.form.formComponent.add.detailData = {}
        }
      } else if (item.action === 'VIEW') {
        this.toView(item, row)
      } else if (item.action === 'EDIT') {
        this.toEdit(item, row)
      } else if (item.action === 'DELETE') {
        this.toDelete(item, row)
      } else if (item.action === 'EXCEL') {
        this.exportExcel(item.url, item.fileName)
      }
      this.$emit('on-button-action', { item, row })
    },
    // 新加的导出！！！！
    exportExcel(url, fileName) {
      const that = this
      const data = that.$wtUtil.toFormData(that.form)
      const _timer = (new Date()).getTime()
      const _fileName = (fileName || '工单') + _timer + '.xlsx'
      if (this.form.formComponent.list) {
        if (this.form.formComponent.list.params && typeof this.form.formComponent.list.params === 'function') {
          data.formData = Object.assign({}, data.formData, this.form.formComponent.list.params())
        } else if (this.form.formComponent.list.params) {
          data.formData = Object.assign({}, data.formData, this.form.formComponent.list.params)
        }
      }
      this.$wtUtil.downloadFile({
        url: url,
        data: that.form.hidePage ? data.formData : data,
        fileName: _fileName
      }).then((res) => {
        console.log('导出成功')
      }).catch((err) => {
        that.$message({ message: err, type: 'error' })
      })
    },
    getDataValue(row, item) {
      if (row && item && item.key && item.filter && this.$options.filters[item.filter]) {
        return this.$options.filters[item.filter](row[item.key])
      } else if (row && item && item.key) {
        return row[item.key]
      }
      return ''
    },
    getDataValueClass(row, item) {
      if (item.filter && !item.filterClass) {
        item.filterClass = item.filter + '_Class'
      }
      if (row && item && item.key && item.filterClass && this.$options.filters[item.filterClass]) {
        return this.$options.filters[item.filterClass](row[item.key])
      }
      return ''
    },
    toView(item, row) {
      //  点击单条查看
      this.isViewDialogVisible = true
      if (this.form.formComponent && this.form.formComponent.view && this.form.formComponent.view.value && !this.form.formComponent.view.noRequest) {
        this.$store.dispatch(this.form.formComponent.view.value, row.id)
      }
      // 不使用store
      if (this.form.formComponent && this.form.formComponent.view && this.form.formComponent.view.detailData) {
        this.form.formComponent.view.detailData = row
      }
    },
    toEdit(item, row) {
      //  点击单条编辑
      this.isEditDialogVisible = true
      if (this.form.formComponent && this.form.formComponent.edit && this.form.formComponent.edit.value && !this.form.formComponent.edit.noRequest) {
        this.$store.dispatch(this.form.formComponent.edit.value, row.id).then(() => {}).catch(() => {})
      }
      // 不使用store
      if (this.form.formComponent && this.form.formComponent.edit && this.form.formComponent.edit.detailData) {
        this.form.formComponent.edit.detailData = row
      }
    },
    toDelete(item, row) {
      //  点击单条删除
      const that = this
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.requestDelete(item, row)
      }).catch(() => {
      })
    },
    requestDelete(item, row) {
      const url = (this.form.formComponent && this.form.formComponent.delete ? this.form.formComponent.delete.value : '')
      const that = this
      request({
        url: url,
        method: 'post',
        data: { list: [row.id] }
      }).then(response => {
        // that.$emit('request-form-list')
        this.$emit('on-button-action', { item, row })
        that.requestList()
      }).catch(error => {
        console.log('error', error)
      })
    },
    toDeleteMutil(row, item) {
      if (!this.form.formSelectedList || this.form.formSelectedList.length <= 0) {
        this.$alert('请选中至少一列数据', '提示', {
          type: 'error',
          confirmButtonText: '确定'
        }).then(() => {
        }).catch(() => {})
        return
      }
      const that = this
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const dataIdList = []
        that.form.formSelectedList.forEach((item) => {
          dataIdList.push(item.id)
        })
        that.requestDeleteMutil(dataIdList)
      }).catch(() => {
      })
    },
    requestDeleteMutil(dataIdList) {
      const url = (this.form.formComponent && this.form.formComponent.delete ? this.form.formComponent.delete.value : '')
      const that = this
      request({
        url: url,
        method: 'post',
        data: { list: dataIdList }
      }).then(response => {
        that.requestList()
        that.$emit('on-button-action', 'update')
      }).catch(error => {
        console.log('error', error)
      })
    },
    requestList() {
      if (this._events && this._events['request-form-list']) {
        this.$emit('request-form-list')
      } else if (this.$parent && this.$parent.requestFormList) {
        this.$parent.requestFormList()
      }
    },
    selectedListId() {
      const idList = []
      if (this.form.formSelectedList) {
        this.form.formSelectedList.forEach((item) => {
          idList.push(item.id)
        })
      }
      return idList
    },
    // 导入
    onSuccess(file) {
      setTimeout(() => {
        this.importLoading.close()
        this.clearTimer()
        if (file.code === '0') {
          this.$message({ type: 'success', message: '导入成功' })
          this.$emit('request-form-list')
        } else {
          this.$message({ type: 'error', message: file.msg })
        }
        this.importList = []
      })
    },
    beforeUpload() {
      this.importLoading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    clearTimer() {
      clearInterval(this.importTimer)
      this.importTimer = null
    }
  },
  computed: {
    isFormTableButtonsDataShow() {
      let value = false
      if (this.form.formTableButtonsData) {
        this.form.formTableButtonsData.forEach((item) => {
          if (item.hidden !== undefined && !item.hidden) {
            value = true
          }
        })
      }
      return value
    },
    ...mapState({
      inputData: state => state.excelExport.data
    })
  }
}
</script>

<style scoped>
</style>
